import {
  FormControl,
  FormHelperText,
  FormLabel,
  HStack,
  Radio,
  RadioGroup,
} from '@chakra-ui/react'
import { Visibility_Enum } from '@gql'
import { VisibleObjectType } from '@rolebase/shared/model/visibility'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useVisibilitySentence from '../hooks/useVisibilitySentence'

interface Props {
  objectType: VisibleObjectType
  circleId?: string
  value: Visibility_Enum
  onChange(value: Visibility_Enum): void
  isReadOnly?: boolean
  // Levels that cannot be chosen from here (e.g. Role on a tension carrying a
  // proposal). The current value stays selected if it is one of them.
  disabledLevels?: Visibility_Enum[]
}

const levels = [
  Visibility_Enum.Role,
  Visibility_Enum.Circle,
  Visibility_Enum.Org,
]

// Who can see this? Three levels, the same for every object, and the sentence
// under them names the real role and circles (CONF-02). Replaces the « private »
// switch of the five edit screens.
export default function VisibilityField({
  objectType,
  circleId,
  value,
  onChange,
  isReadOnly,
  disabledLevels = [],
}: Props) {
  const { t } = useTranslation()
  const sentence = useVisibilitySentence(objectType, circleId, value)

  const handleChange = (next: string) => onChange(next as Visibility_Enum)

  return (
    <FormControl>
      <FormLabel>{t('VisibilityField.label')}</FormLabel>
      <RadioGroup value={value} onChange={handleChange}>
        <HStack spacing={6}>
          {levels.map((level) => (
            <Radio
              key={level}
              value={level}
              isReadOnly={isReadOnly}
              isDisabled={level !== value && disabledLevels.includes(level)}
            >
              {t(`VisibilityField.levels.${level}`)}
            </Radio>
          ))}
        </HStack>
      </RadioGroup>
      <FormHelperText>{sentence}</FormHelperText>
    </FormControl>
  )
}
